import favorites from '@motionelements/core/src/store/modules/favorites.js';

export default {
  namespaced: true,
  state: () => favorites.state,
  getters: favorites.getters,
  actions: favorites.actions,
  mutations: favorites.mutations,
};
